var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2.30532 2.46583C2.7124 2.05874 3.37242 2.05874 3.77951 2.46583L17.3474 16.0337C17.7545 16.4408 17.7545 17.1008 17.3474 17.5079C16.9403 17.915 16.2803 17.915 15.8732 17.5079L2.30532 3.94002C1.89823 3.53294 1.89823 2.87292 2.30532 2.46583Z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M17.622 2.30532C18.0291 2.7124 18.0291 3.37242 17.622 3.77951L4.05409 17.3474C3.647 17.7545 2.98698 17.7545 2.5799 17.3474C2.17281 16.9403 2.17281 16.2803 2.5799 15.8732L16.1478 2.30532C16.5549 1.89823 17.2149 1.89823 17.622 2.30532Z","key":1})]);
}

Close.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = Close;

Close.default = Close;
